export default "__VITE_ASSET__DTOYS7JB__"